export default "__VITE_ASSET__035683fb__"